import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';
import { fetchLinkedSpaces as fetchLinkedSpacesRest } from 'rest/linked-spaces';
import type { LinkedSpacesResponse } from 'rest/linked-spaces';
import type { AjaxError } from 'rxjs/observable/dom/AjaxObservable';
import type {
    FetchLinkedSpacesAction,
    FetchLinkedSpacesSuccessAction,
    FetchLinkedSpacesFailureAction,
} from 'state/actions/linked-spaces';
import { FETCH_LINKED_SPACES, fetchLinkedSpacesSuccess, fetchLinkedSpacesFailure } from 'state/actions/linked-spaces';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { sendEvent } from '@atlassian/help-center-common-util/analytics';

export const fetchLinkedSpacesEpic: Epic<
    FetchLinkedSpacesAction,
    FetchLinkedSpacesSuccessAction | FetchLinkedSpacesFailureAction
> = (action$) =>
    action$.ofType(FETCH_LINKED_SPACES).mergeMap((action) => {
        const { meta } = action.payload;

        return fetchLinkedSpacesRest()
            .map((response: LinkedSpacesResponse) => {
                if (meta?.analyticsSuccessEvent) {
                    sendEvent(meta.analyticsSuccessEvent);
                }
                return fetchLinkedSpacesSuccess(response.linkedSpaces.map((space) => space.spaceKey));
            })
            .catch((error: AjaxError) => {
                if (meta?.analyticsFailureEvent) {
                    const failureEvent = meta.analyticsFailureEvent.update((payload: UIAnalyticsEvent) => ({
                        ...payload,
                        status: error.status,
                    }));
                    sendEvent(failureEvent);
                }
                return Observable.of(fetchLinkedSpacesFailure(error));
            });
    });
